export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"keywords","content":"Thợ Săn Đại Dương"},{"property":"og:image","content":"https://globalqn.qijihdhk.com/hwglobal/buyuPreheat/website/vn/game_icon.png"},{"property":"og:image:width","content":"50"},{"property":"og:image:height","content":"50"},{"property":"og:url","content":"https://pt57-alihk-prince-pay.arksgame.com"}],"link":[{"rel":"icon","type":"image/png","href":"https://globalqn.qijihdhk.com/hwglobal/buyuPreheat/website/vn/game_icon.png"}],"style":[],"script":[{"src":"https://globalqn.qijihdhk.com/hwglobal/buyuPreheat/website/js/tuyoosdk_tthmomo_release_20241104.js","async":true}],"noscript":[],"title":"Thợ Săn Đại Dương"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false